<template lang="pug">
  .dropdown(v-on-clickaway="away", :class="classes")
    .dropdown-trigger(@click.stop="toggle", ref="trigger")
      slot(name="toggle")
    .dropdown-menu(v-show="!disabled && (isOpen)", ref="dropdownMenu")
      .dropdown-wrap(@click="hide")
        slot(name="menu")
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'DropdownMenu',
  components: {
  },
  mixins: [ clickaway ],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  mounted () {
    //console.log('user', user)
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  computed: {
    classes () {
      let classes = []

      classes.push(`dropdown-${this.type}`)
      classes.push(`align-${this.align}`)

      return classes
    }
  },
  methods: {
    toggle () {
      if (this.disabled) return
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.$emit('openDropdown')
      } else {
        this.$emit('closeDropdown')
      }
    },
    hide () {
      this.away()
    },
    away () {
      //console.log('away')
      this.isOpen = false
    }
  },
  watch: {
    open: function (val) {
      //console.log('manual close = ' + val);
      this.isOpen = val
    }
  },
}
</script>

<style lang="stylus" scoped>
  .dropdown
    display inline-block
    position relative
    
    &.dropdown-header
      .dropdown-menu
        top 53px

    .dropdown-menu
      left auto
      position absolute
      right 0
      z-index 1
      text-align left
      max-height 350px
      overflow auto
      .dropdown-wrap
        background-color #fff
        border $border-default
        //box-shadow 0 6px 12px rgba(0,0,0,.175)
        border-radius 4px
        margin 2px 0 0

      .list-menu
        font-size 16px
        padding 5px 10px
        .list-item
          border-radius 4px
          cursor pointer
          display block
          padding 6px 10px
          white-space nowrap
          &:hover
            background-color #f5f5f5
        & + .list-menu
          border-top 1px solid #e5e5e5

    &.align-center
      .dropdown-menu
        transform translate(25%, 0)
</style>
